module.exports = '4.0.0';



// WEBPACK FOOTER //
// ./src/version.js